import GridOffIcon from '@mui/icons-material/GridOff';
import GridOnIcon from '@mui/icons-material/GridOn';
import { Box, SxProps, Tooltip, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  selectShowSurroundingBlocksOnMap,
  toggleShowSurroundingBlocksOnMap,
} from '../../onboardingSlice';

interface Props {
  sx?: SxProps;
  dark?: boolean;
}

const ShowSurroundingBlocksOnMapButton: React.FC<Props> = ({
  sx = {},
  dark = true,
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const showSurroundingBlocksOnMap = useAppSelector(
    selectShowSurroundingBlocksOnMap
  );

  const handleClick = () => {
    dispatch(toggleShowSurroundingBlocksOnMap());
  };

  return (
    <Tooltip
      title={t(
        showSurroundingBlocksOnMap
          ? 'Hide other blocks in ranch.'
          : 'Show other blocks in ranch.',
        { ns: 'common' }
      )}
      placement='top'
    >
      <Box
        sx={{
          ...sx,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: dark
            ? theme.colors.darkTheme.grey.medium
            : theme.colors.common.softWhite,
          color: theme.colors.common.white,
          borderRadius: theme.borderRadius.primary,
          p: '0.6rem',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        {showSurroundingBlocksOnMap ? <GridOnIcon /> : <GridOffIcon />}
      </Box>
    </Tooltip>
  );
};

export default ShowSurroundingBlocksOnMapButton;
